import React from "react";
import {Flex, Spin} from "antd";
import {CheckOutlined, CloseOutlined, QuestionOutlined} from "@ant-design/icons";

const icon = {
  'check': <CheckOutlined style={{color: 'rgba(82, 196, 26, 1)', fontSize: 20}}/>,
  'delete': <CloseOutlined style={{color: 'rgba(243, 45, 45, 1)', fontSize: 20}}/>
}

export const MarkSystem = React.memo(({
                                        mark, handleButtonClick
                                      }: any) => {
  return (
    <Flex  align='center' gap={8} justify='center'>
      <div style={{display: 'flex', justifyContent: 'center'}}>
        <div style={{
          width: 50,
          height: 50,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <h1>{mark?.mark}</h1>
        </div>
      </div>
      {
        mark.button &&
        <Flex align='center' justify='center' style={{cursor: 'pointer', width: 30, height: 30}} onClick={() => handleButtonClick(mark.button)}>
          {/*// @ts-ignore*/}
          {icon[mark.button.icon] ? icon[mark.button.icon] :
            <QuestionOutlined style={{color: 'rgba(251, 173, 47, 1)', fontSize: 20}}/>}
        </Flex>
      }
    </Flex>
  )
})